import { CardFee, CardFeeDetailsV2DTO, CardFeesData, CatalogueItem, TerminalType } from '../types';
import { CartItem } from '../types/application/cart';

const CARD_PRESENT_TEXT = 'Card Present';

/**
 * This function determines the pricing tier type based on business rules:
 * If we have any products with variable card fees then we use the variable card fees\
 * else we use the fixed card fees
 * @param cardFees
 * @returns The pricing tier type
 */
function getPricingTierType(cardFees: CardFeeDetailsV2DTO) {
  return Object.values(cardFees).some((fees) =>
    fees.some((item) => item.pricing_tier === 'Variable'),
  )
    ? 'Variable'
    : 'Fixed';
}

/**
 * @deprecated This function does not use the cart(introduced with DPO)
 *
 *  This function uses the catalogue products and to filter the fees returned.
 * @param {CatalogueItem[]} catalogueItems
 * @param {CardFeesData[] | undefined } cardFees
 * @returns The fees for products that are in the cart
 */
export function getFees(
  catalogueItems: CatalogueItem[],
  cardFees?: CardFeeDetailsV2DTO,
): CardFeesData[] | undefined {
  if (cardFees) {
    const devices = catalogueItems
      .filter((catalogueItem) => catalogueItem.device.quantity > 0)
      .map((catalogueItem) => catalogueItem.device.title);

    const feesFilteredByDevice: CardFeeDetailsV2DTO = Object.keys(cardFees)
      .filter((key) => devices.includes(key))
      .reduce((obj, key) => {
        obj[key] = cardFees[key];
        return obj;
      }, {});

    const pricingTierType = getPricingTierType(feesFilteredByDevice);

    return Object.values(feesFilteredByDevice).filter((items) =>
      items.every((item) => item.pricing_tier === pricingTierType),
    )[0];
  }
}

/**
 *  This function uses the products in the cart and to filter the fees returned.
 * @param {CartItem[]} cart
 * @param {CardFeesData[] | undefined } cardFees
 * @returns The fees for products that are in the cart
 */
export function getFeesDPO(
  cart: CartItem[],
  cardFees?: CardFeeDetailsV2DTO,
): CardFeesData[] | undefined {
  if (cardFees) {
    const devices = cart.map((cartItem) => cartItem.title);

    const feesFilteredByDevice: CardFeeDetailsV2DTO = Object.keys(cardFees)
      .filter((key) => devices.includes(key))
      .reduce((obj, key) => {
        obj[key] = cardFees[key];
        return obj;
      }, {});

    const pricingTierType = getPricingTierType(feesFilteredByDevice);

    return Object.values(feesFilteredByDevice).filter((items) =>
      items.every((item) => item.pricing_tier === pricingTierType),
    )[0];
  }
}

/**
 *  This function is used to map the card fees data returned from the card fees API to the application card fee data
 * @param {CardFeesData} cardFeeData
 * @returns formatted card fees
 */
export function getCardFee(cardFeeData: CardFeesData): CardFee {
  const cardFees: CardFee = {
    percentage: cardFeeData.percentage,
    cardProviderName: `${cardFeeData.demographic} - ${cardFeeData.product_name} -  ${cardFeeData.card_type}`,
    terminalType:
      cardFeeData.fee_category === CARD_PRESENT_TEXT
        ? TerminalType.CARD_PRESENT
        : TerminalType.CARD_NOT_PRESENT,
  };
  return cardFees;
}
